export default __webpack_public_path__ + "static/media/generalSettings.8262c4fa.png";